<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader || loadingData) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader && !loadingData) {
<form class="issue-form">
    <div class="fluid-container">
      <!-- Short Description -->
      <div class="form-group">
        <label class="async-loader-container">
          Short Description*
          <i class="glyphicon glyphicon-info-sign info-sign" title="This description gets submitted to IRS"></i>
          <input class="form-control"
                 type="text"
                 [(ngModel)]="shortDescription"
                 (ngModelChange)="onShortDescriptionChange()"
                 #shortDescInput="ngModel"
                 name="shortDesc"
                 maxlength="35"
                 required
                 [class.error-input]="(shortDescInput.invalid && shortDescInput.touched) || (!isShortDescUnique && shortDescInput.touched)">
          @if (shortDescInput.invalid && shortDescInput.touched) {
<span class="form-error-container">
            @if (shortDescInput.errors?.['required']) {
<span>
              Short Description is required.
            </span>
}
            @if (shortDescInput.errors?.['maxlength']) {
<span>
              Short Description has a maximum limit of 35 characters.
            </span>
}
          </span>
}
          @if (!isShortDescUnique && shortDescInput.touched && shortDescription) {
<span class="form-error-container">
            Short Description must be unique!
          </span>
}
        </label>
      </div>

      <!-- Detailed Description -->
      <div class="form-group">
        <label class="async-loader-container">
          Detailed Description*
          <textarea class="form-control"
                    [(ngModel)]="detailedDescription"
                    (ngModelChange)="onDetailedDescriptionChange()"
                    #detailedDescInput="ngModel"
                    name="detailedDesc"
                    required
                    [class.error-input]="(detailedDescInput.invalid && detailedDescInput.touched) || (!isDetailedDescUnique && detailedDescInput.touched)"></textarea>
          @if (detailedDescInput.invalid && detailedDescInput.touched) {
<span class="form-error-container">
            @if (detailedDescInput.errors?.['required']) {
<span>
              Detailed Description is required.
            </span>
}
          </span>
}
          @if (!isDetailedDescUnique && detailedDescInput.touched && detailedDescription) {
<span class="form-error-container">
            Detailed Description must be unique!
          </span>
}
        </label>
      </div>

      <!-- Standard Description -->
      <div class="form-group">
        <label>
          Standard Description*
          <select class="form-control"
                  [(ngModel)]="selectedStdDesc"
                  #stdDescInput="ngModel"
                  name="stdDesc"
                  required
                  [class.error-input]="stdDescInput.invalid && stdDescInput.touched">
            <option [ngValue]="null">-- Select Standard Description --</option>
            @for (item of stdDescList; track $index) {
<option [ngValue]="item">
              {{item.qar_desc}}
            </option>
}
          </select>
          @if (stdDescInput.invalid && stdDescInput.touched) {
<span class="form-error-container">
            @if (stdDescInput.errors?.['required']) {
<span>
              QAR Standard Description is required.
            </span>
}
          </span>
}
        </label>
      </div>

      <!-- Tax Year & Scenario -->
      <div class="form-group">
        <label>Tax Year & Scenario*</label>
        <div class="table-scroll">
          <table>
            <thead>
              <tr>
                <th class="sticky-col col-md-4" style="text-align: center;">Tax Year</th>
                <th class="sticky-col col-md-8" style="text-align: center;">Scenario</th>
              </tr>
            </thead>
            <tbody>
              @for (item of taxYearScenarios; track $index; let idx = $index) {
<tr>
                @if (item.scenarioList && item.scenarioList.length > 0) {
<td class="col-md-4 text-center">
                  {{ item.tax_year }} ({{ item.selectedScenario ? item.selectedScenario.length : 0 }} of {{ item.scenarioList.length }})
                </td>
}
                @if (item.scenarioList && item.scenarioList.length > 0) {
<td class="col-md-8 text-center">
                  <div class="custom-multiselect" 
                       [class.open]="item.dropdownOpen">
                    <button type="button" 
                            class="mul-select-btn"
                            (click)="toggleDropdown(idx, $event)">
                      <span class="selected-text">{{ getSelectedText(item) }}</span>
                      <span class="caret"></span>
                    </button>
                    @if (item.dropdownOpen) {
<div class="dropdown-menu" 
                        
                         (click)="$event.stopPropagation()">
                      <div class="dropdown-header">
                        <button type="button" 
                                class="dropdown-action-btn"
                                (click)="selectAll(item); $event.stopPropagation()">
                          Select all
                        </button>
                        <button type="button" 
                                class="dropdown-action-btn"
                                (click)="unselectAll(item); $event.stopPropagation()">
                          Unselect all
                        </button>
                      </div>
                      <div class="dropdown-items">
                        @for (scenario of item.scenarioList; track $index) {
<label 
                               class="dropdown-item"
                               (click)="$event.stopPropagation()">
                          <input type="checkbox"
                                 [checked]="isSelected(item, scenario)"
                                 (change)="toggleSelection(item, scenario)">
                          <span>{{ scenario.scenario_desc }}</span>
                        </label>
}
                      </div>
                    </div>
}
                  </div>
                </td>
}
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>

      <!-- Primary Citation -->
      <div class="form-group">
        <label class="async-loader-container">
          Primary Citation
          <textarea class="form-control"
                    [(ngModel)]="primaryCitation"
                    name="primaryCitation"></textarea>
        </label>
      </div>

      <!-- Multi-year Disclosure -->
      <div class="form-group">
        <label class="async-loader-container">
          Check here if item that has effect on more than one line item or is a multi-year disclosure
          <input type="checkbox"
                 [(ngModel)]="multiYear"
                 (ngModelChange)="toggleMultiYear()"
                 name="multiYear"
                 style="margin-left: 8px;">
        </label>
        @if (multiYear) {
<select
                class="form-control"
                [(ngModel)]="multiYearDropDown"
                name="multiYearDropDown">
          @for (item of multiYearDropDownOptions; track $index) {
<option [ngValue]="item">
            {{item.desc}}
          </option>
}
        </select>
}
      </div>

      <!-- Adjustment Type -->
      <div class="form-group">
        <label class="async-loader-container">
          Adjustment Type
          <select class="form-control"
                  [(ngModel)]="adjType"
                  name="adjType">
            <option [ngValue]="null">-- Select Adjustment Type --</option>
            @for (item of adjTypeOptions; track $index) {
<option [ngValue]="item">
              {{item.CODE_DESC}}
            </option>
}
          </select>
        </label>
      </div>

      <!-- Filed Schedule/Form Check -->
      <div class="form-group">
        <label class="async-loader-container">
          Check here if you filed a Schedule UTP or Form 8275/R with your return for the tax year
          <input type="checkbox"
                 [(ngModel)]="filedScheduleFormCheck"
                 name="filedScheduleFormCheck"
                 style="margin-left: 8px;">
        </label>
      </div>

      <!-- Timing -->
      <div class="form-group">
        <label class="async-loader-container">
          Timing
          <select class="form-control"
                  [(ngModel)]="timing"
                  name="timing">
            <option [ngValue]="null">-- Select Timing --</option>
            @for (item of timingOptions; track $index) {
<option [ngValue]="item">
              {{item.desc}}
            </option>
}
          </select>
        </label>
      </div>

      <!-- Effect on Other Years -->
      <div class="form-group">
        <label class="async-loader-container">
          Effect on Other Years
        </label>
        <div class="radio-group-vertical">
          <label class="radio-label">
            <input type="radio"
                   name="effectYrs"
                   [(ngModel)]="effectYrs"
                   value="Yes">
            Yes
          </label>
          <label class="radio-label">
            <input type="radio"
                   name="effectYrs"
                   [(ngModel)]="effectYrs"
                   value="No">
            No
          </label>
        </div>
      </div>

      <!-- Explanation -->
      <div class="form-group">
        <label class="async-loader-container">
          Explanation
          <textarea class="form-control"
                    [(ngModel)]="explanation"
                    name="explanation"></textarea>
        </label>
      </div>
    </div>
  </form>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked || !isFormValid() || invalidTaxYearScenarios"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset Form</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

